
import {take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { superLocalStorage } from '~common/app/shared/utils/local-storage';

// I18N

import { french  } from '../../../i18n/fr';
import { english } from '../../../i18n/en';

@Injectable()
export class AppService {
  lang: string;
  culture: string;
  title: string;
  warningDisplayed: boolean;

  constructor(
    private titleService: Title,
    private translateService: TranslateService,
    private router: Router,
  ) {
    this.lang = superLocalStorage.get('lang') || 'en';
    this.culture = superLocalStorage.get('culture') || 'GB';
    this.translateTitleOnLangChange();
  }

  getCountryList(object = false) {
    const currentLang = this.translateService.currentLang;
    const messages = this.translateService.translations[currentLang];
    const countries = messages.shared.countries;

    if (object) {
      return countries;
    }

    return Object.keys(countries);
  }

  setLanguage(lang: string) {
    this.lang = lang;
    this.translateService.use(lang);
    superLocalStorage.set('lang', lang);
  }

  getLanguage() {
    return this.lang;
  }

  setCulture(culture: string) {
    this.culture = culture;
    superLocalStorage.set('culture', culture);
  }

  getCulture() {
    return this.culture;
  }

  setLanguageAndCulture(string: string) {
    const [ lang, culture ] = string.split('-');
    this.setLanguage(lang);
    this.setCulture(culture);
  }

  getLanguageAndCulture() {
    return this.lang + '-' + this.culture;
  }

  setTitle(key) {
    this.title = key;

    this.translateService.get(key).pipe(take(1)).subscribe((title) => {
      this.titleService.setTitle(title + ' — Paylead');
    });
  }

  translateTitleOnLangChange() {
    this.translateService.onLangChange.subscribe(e => {
      if (!this.title) {
        return;
      }
      this.translateService.get(this.title).pipe(take(1)).subscribe((title) => {
        this.titleService.setTitle(title + ' — Paylead');
      });
    });
  }

  detectLanguage() {
    this.translateService.addLangs(['en', 'fr']);
    this.translateService.setDefaultLang('fr');

    const savedLang    = superLocalStorage.get('lang');
    const userLang     = this.translateService.getBrowserLang();
    const defaultLang  = savedLang || userLang || this.translateService.getDefaultLang();
    const savedCulture = superLocalStorage.get('culture');

    this.setLanguage(defaultLang);
    this.setCulture(savedCulture);

    this.translateService.use(defaultLang);
    this.translateService.setTranslation('en', english);
    this.translateService.setTranslation('fr', french);

    this.translateService.onLangChange.subscribe(e => {
      this.setLanguage(e.lang);
    });
  }
}
